// extracted by mini-css-extract-plugin
export var buttonItem = "Portfolio-module--buttonItem--8AKmp";
export var buttonItems = "Portfolio-module--buttonItems--5Sb4I";
export var container = "Portfolio-module--container--c5Di2";
export var containerNarrow = "Portfolio-module--container-narrow--kLT38";
export var containerWide = "Portfolio-module--container-wide--q-3AY";
export var fontDisplay = "Portfolio-module--font-display--UC+4x";
export var fontSansSerif = "Portfolio-module--font-sans-serif--MH5-k";
export var gatsbyImageWrapper = "Portfolio-module--gatsby-image-wrapper--+U9j1";
export var hover = "Portfolio-module--hover--KpVAd";
export var linkUl = "Portfolio-module--link-ul--r6B3c";
export var lock = "Portfolio-module--lock--bEgvt";
export var mainInner = "Portfolio-module--main-inner--KiUPe";
export var modal = "Portfolio-module--modal--dgh-3";
export var modal__caption = "Portfolio-module--modal__caption--uq48N";
export var modal__description = "Portfolio-module--modal__description--o7waV";
export var modal__director = "Portfolio-module--modal__director--ViSj5";
export var modal__icon = "Portfolio-module--modal__icon--J0xsr";
export var modal__image = "Portfolio-module--modal__image--3GDuE";
export var modal__image_narrow = "Portfolio-module--modal__image_narrow--Uudfm";
export var modal__link = "Portfolio-module--modal__link--s2Hh0";
export var modal__text = "Portfolio-module--modal__text--edo00";
export var modal__text_wide = "Portfolio-module--modal__text_wide--0o93M";
export var modal__trailer = "Portfolio-module--modal__trailer--cPecr";
export var onlyForMedium = "Portfolio-module--only-for-medium--nONiP";
export var onlyForSmall = "Portfolio-module--only-for-small--mOhnl";
export var pageTitleWrapper = "Portfolio-module--page-title-wrapper--NyLIE";
export var portfolio = "Portfolio-module--portfolio--QlE-n";
export var spFull = "Portfolio-module--sp-full--Biptk";
export var textCenter = "Portfolio-module--text-center--gNrtc";
export var textLeft = "Portfolio-module--text-left--YfpDD";
export var textRight = "Portfolio-module--text-right--e-WtY";